module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded && !_vm.config.fixTop, 'active': _vm.active
    },
    style: (_vm.config.fixTop ? 'height: 63px' : '')
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), _c('div', {
    staticClass: "search",
    class: {
      'fixed': _vm.config.fixTop
    }
  }, [_c('div', {
    staticClass: "view-flex view-flex-middle"
  }, [_vm._m(0), _vm._v(" "), (_vm.res.config.scanCode) ? _c('div', {
    staticClass: "scancode"
  }, [_c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-scan"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("扫码购")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-flex-item view-flex view-flex-middle view-flex-center search-box"
  }, [_c('i', {
    staticClass: "search-icon"
  }), _vm._v(" 搜索想要的商品\n      ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1597bc2b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1597bc2b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/search.vue
// module id = 2491
// module chunks = 0